export class PayOne {
    constructor(payoneRequestData = false) {
        this._payoneRequestData = payoneRequestData;
        this._validated = false;
        this._payoneIframesInited = false;
        this._pseudocardpan = false;
        this._successCallback = false;
        this._errorCallback = false;
        this._creditcardRequest = new Request('GET', document.location.pathname + '/creditcard-request-data');
        this.init();
    };
    
    get validated() {
        return this._validated;
    };
    
    get pseudocardpan() {
        return this._pseudocardpan;
    };
    
    set pseudocardpan(value) {
        this._pseudocardpan.value = value;
    };
    
    set success(value) {
        this._successCallback = value;
    };
    
    set error(value) {
        this._errorCallback = value;
    }
    
    init() {
        window.payoneCallback = function(response) {
            if (response.status === 'VALID') {
                this._validated = true;
                this._pseudocardpan = response.pseudocardpan;
                if(this._successCallback) {
                    this._successCallback({
                        status: 'ok',
                        pseudocardpan: response.pseudocardpan
                    })
                }
            } else {
                if(this._errorCallback) {
                    this._errorCallback({
                        status: 'error',
                        data: response.errormessage
                    });
                }
            }
        }.bind(this);
    };
    
    initCreditCard(callback = false) {
        if(!this._payoneIframesInited) {
            if(!this._payoneRequestData) {
                this._creditcardRequest.call(response => {
                    if(response.status == "ok") {
                        this.createIframe(response.data);
                    }
                    if(callback) {
                        callback(response);
                    }
                });
            } else {
                this.createIframe(this._payoneRequestData);
                if(callback) {
                    callback({
                        status: 'ok'
                    });
                }
            }
        }
    };
    
    checkCreditCard() {
        this._iframes.creditCardCheck('payoneCallback');
    };
    
    createIframe(payoneRequestData) {
        if(this._payoneIframesInited)
            return false
        
        let supportedCardtypes = ['V', 'M']
        let config = {
            fields: {
                cardpan: {
                    selector: "payment-cardpan",
                    type: "text"
                },
                cardcvc2: {
                    selector: "payment-cardcvc2",
                    type: "text",
                    size: "4",
                    maxlength: "4",
                    length: { "V": 3, "M": 3 }
                },
                cardexpiremonth: {
                    selector: "payment-cardexpiremonth",
                    type: "select",
                    size: "2",
                    maxlength: "2",
                    iframe: {
                        width: "100%"
                    },
                },
                cardexpireyear: {
                    selector: "payment-cardexpireyear",
                    type: "select",
                    iframe: {
                        width: "100%"
                    },
                }
            },
            defaultStyle: {
                input: "display: block; width: 100%; height: 44px; padding: 0.375rem 0.75rem; font-size: 14px; font-weight: 400; line-height: 1.5; color: #495057; background-color: #f0f0f0; background-clip: padding-box; border: none; border-radius: 5px; transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;",
                inputFocus: "outline: none; display: block; width: 100%; height: 44px; padding: 0.375rem 0.75rem; font-size: 14px; font-weight: 400; line-height: 1.5; color: #495057; background-color: #f0f0f0; background-clip: padding-box; border: none; border-radius: 5px; transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;",
                select: "display: block; width: 100%; height: calc(1.5em + 0.75rem + 2px); padding: 0.375rem 0.75rem; font-size: 1rem; font-weight: 400; line-height: 1.5; color: #495057; background-color: #fff; background-clip: padding-box; border: 1px solid #ced4da; border-radius: 0.25rem; transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;",
                selectFocus: "outline: none; display: block; width: 100%; height: calc(1.5em + 0.75rem + 2px); padding: 0.375rem 0.75rem; font-size: 1rem; font-weight: 400; line-height: 1.5; color: #495057; background-color: #fff; background-clip: padding-box; border: 1px solid #ced4da; border-radius: 0.25rem; transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;",
                iframe: {
                    height: "44px",
                    width: "100%",
                }
            },
            autoCardtypeDetection: {
                supportedCardtypes: supportedCardtypes,
            },
            language: Payone.ClientApi.Language.de,
            error: "error"
        };
        
        Payone.ClientApi.Language.de.placeholders.cardpan = 'Kreditkartennummer';
        Payone.ClientApi.Language.de.placeholders.cvc = 'Kreditkartenprüfnummer';
        
        Payone.ClientApi.Language.de.months.month1 = "01";
        Payone.ClientApi.Language.de.months.month2 = "02";
        Payone.ClientApi.Language.de.months.month3 = "03";
        Payone.ClientApi.Language.de.months.month4 = "04";
        Payone.ClientApi.Language.de.months.month5 = "05";
        Payone.ClientApi.Language.de.months.month6 = "06";
        Payone.ClientApi.Language.de.months.month7 = "07";
        Payone.ClientApi.Language.de.months.month8 = "08";
        Payone.ClientApi.Language.de.months.month9 = "09";
        Payone.ClientApi.Language.de.months.month10 = "10";
        Payone.ClientApi.Language.de.months.month11 = "11";
        Payone.ClientApi.Language.de.months.month12 = "12";

        this._iframes = new Payone.ClientApi.HostedIFrames(config, payoneRequestData);
        this._payoneIframesInited = true;
    };
}
